import { render, staticRenderFns } from "./EsgRating.vue?vue&type=template&id=bd27397e&scoped=true"
import script from "./EsgRating.vue?vue&type=script&setup=true&lang=js"
export * from "./EsgRating.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EsgRating.vue?vue&type=style&index=0&id=bd27397e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd27397e",
  null
  
)

export default component.exports